<script setup lang="ts">
import { BAccordion, BAccordionItem } from 'bootstrap-vue-next';

import MarkdownRenderer from '~/common/components/MarkdownRenderer.vue';

defineProps<{
  title: string;
  detailsMarkdown: string;
  rewardsMarkdown: string;
}>();
</script>

<template>
  <div>
    <h5 class="mb-2">{{ title }}</h5>
    <BAccordion class="mb-2">
      <BAccordionItem
        title="Details"
        :visible="false"
      >
        <MarkdownRenderer
          class="overflow-auto"
          :markdown-content="detailsMarkdown"
        />
      </BAccordionItem>
      <BAccordionItem
        title="Rewards"
        :visible="false"
      >
        <MarkdownRenderer
          class="overflow-auto"
          :markdown-content="rewardsMarkdown"
        />
      </BAccordionItem>
    </BAccordion>
  </div>
</template>
